import React, { useContext, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import MenuIcon from '@mui/icons-material/Menu'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { MdRefresh } from 'react-icons/md'
import PropTypes from 'prop-types'

import { CurrentOrganizationContext } from '@context/CurrentOrganization'
import { UserContext } from '@context/UserContext'

import styles from './AppTopBar.module.scss'

const homePath =
  process.env.REACT_APP_environment_type === 'clinicvu' ? '/patients' : '/users'

const AppTopBar = ({ isMobile, onMenuClick }) => {
  const navigate = useNavigate()
  const { organizations } = useContext(UserContext)
  const { currentOrganization } = useContext(CurrentOrganizationContext)

  const portalName = useMemo(() => {
    if (process.env.REACT_APP_environment_type !== 'clinicvu') return ''
    const match = organizations?.find(
      (o) => String(o.id) === String(currentOrganization)
    )
    return match?.name || ''
  }, [organizations, currentOrganization])

  const logoSrc =
    process.env.REACT_APP_environment_type === 'clinicvu'
      ? '/assets/clinicvu-logo.svg'
      : '/assets/biovu-logo.svg'

  const handleLogoClick = () => {
    navigate(homePath)
  }

  return (
    <header
      className={`${styles.topBar} ${isMobile ? styles.topBarMobile : ''}`}
    >
      <div
        className={`${styles.row} ${isMobile ? styles.rowMobile : styles.rowDesktop}`}
      >
        <div className={styles.left}>
          {isMobile && (
            <IconButton
              size="large"
              edge="start"
              aria-label="open menu"
              onClick={onMenuClick}
              className={styles.menuBtn}
            >
              <MenuIcon />
            </IconButton>
          )}
          {!isMobile &&
            process.env.REACT_APP_environment_type === 'clinicvu' &&
            portalName && (
            <Typography variant="body2" className={styles.portalLabel}>
              <span className={styles.portalMuted}>Portal</span>
              <span className={styles.portalName}>{portalName}</span>
            </Typography>
          )}
        </div>

        <div className={styles.center}>
          <button
            type="button"
            className={styles.logoBtn}
            onClick={handleLogoClick}
            aria-label="Home"
          >
            <img src={logoSrc} alt="" className={styles.logo} />
          </button>
        </div>

        <div className={styles.right}>
          <Tooltip title="Refresh">
            <IconButton
              aria-label="Refresh"
              onClick={() => window.location.reload()}
              className={styles.actionBtn}
              size="small"
            >
              <MdRefresh size={22} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <div className={styles.rule} aria-hidden />
    </header>
  )
}

AppTopBar.propTypes = {
  isMobile: PropTypes.bool,
  onMenuClick: PropTypes.func
}

AppTopBar.defaultProps = {
  isMobile: false,
  onMenuClick: () => {}
}

export default AppTopBar
